<div *ngIf="surveysData" class="container">
    <div class="row mb-2">
        <span style="font-size: 26px; font-weight: bold" class="ml-auto mr-auto" i18n="@@covid.result.surveys">
            Rezultati COVID-19
            <span *ngIf="!isNew">vprašalnikov</span>
            <span *ngIf="isNew">vprašalnika</span>
        </span>
    </div>
    <hr />
    <ng-container *ngIf="!isNew">
        <!-- Old version -->
        <div class="d-flex row justify-content-center">
            <div class="col-12 col-lg-8">
                <covid-form [readOnly]="true" [surveyData]="surveysData[0]" [surveyType]="'14day'"></covid-form>
            </div>
        </div>
        <hr />
        <div class="d-flex row justify-content-center">
            <div class="col-12 col-lg-8">
                <covid-form [readOnly]="true" [surveyData]="surveysData[1]" [surveyType]="'1day'"></covid-form>
            </div>
        </div>
        <hr />
        <div class="d-flex row justify-content-center">
            <div class="col-12 col-lg-8">
                <covid-form [readOnly]="true" [surveyData]="surveysData[2]" [surveyType]="'0day'"></covid-form>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isNew">
        <!-- New version -->
        <div class="d-flex row justify-content-center">
            <div class="col-12 col-lg-8">
                <covid-form [readOnly]="true" [surveyData]="surveysData[0]" [surveyType]="'new'"></covid-form>
            </div>
        </div>
    </ng-container>
    <hr />
    <div class="row">
        <button
            [disabled]="confirmedByPacient"
            (click)="confirmResults()"
            type="button"
            class="btn m-btn--pill btn-accent m-btn col-6 col-md-2 mr-auto ml-auto m-2 p-3"
        >
            <span *ngIf="confirmedByPacient" i18n="@@covid.confirm">Potrjeno</span>
            <span *ngIf="!confirmedByPacient" i18n="@@covid.cancel">Potrdi</span>
        </button>
    </div>
</div>
